import { Bar } from 'react-chartjs-2';
import { Box, Text } from 'grommet';
import { classificationColors } from '../../../../service/common/constants';
import { Chart, registerables } from 'chart.js';
import { useAppSelector } from '../../../../redux';
import React, { useEffect } from 'react';
import { useResponsiveWrapper } from '../../../estimation-tool/common/components/ResponsiveContextWrapper';

Chart.register(...registerables);

export const ClassificationChart = (): JSX.Element => {
  const chartData = useAppSelector((state) => state.map.classification_data);
  const { size, fontSize } = useResponsiveWrapper();

  useEffect(() => {
    console.log(size, fontSize);
  }, [size, fontSize]);

  if (!chartData) {
    return <></>;
  }
  const lineOptions: any = {
    maintainAspectRatio: false,
    responsive: true,
    layout: {
      padding: 16,
    },
    scales: {
      yAxis: {
        ticks: {
          callback: function (value: number) {
            return value;
          },
          color: '#282828',
          font: {
            weight: 800,
          },
        },
        stacked: true,
      },
      xAxis: {
        stacked: true,
        ticks: {
          color: '#282828',
          maxRotation: 0,
          minRotation: 0,
        },
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          title: function (tooltipItem: any) {
            return tooltipItem[0].label.replace(',', ' - ');
          },
          label: function (context: any) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed.y !== null) {
              label += context.parsed.y.toFixed(2);
            }
            return label;
          },
        },
      },
      legend: {
        position: 'top',
        align: 'end',
        display: false,
        labels: {
          boxHeight: 20,
          boxWidth: 20,
          color: '#282828',
          font: {
            size: 14,
            weight: 400,
          },
        },
      },
    },
  };
  const legendMargin: any = {
    id: 'legendMargin',
    beforeInit: function (chart: any) {
      if (chart.legend) {
        const fitValue = chart.legend.fit;
        chart.legend.fit = function fit() {
          fitValue.bind(chart.legend)();
          return (this.height += 10);
        };
      }
    },
  };

  const data: any = {
    datasets: [
      {
        label: '',
        data: chartData.values.map((item) => item * 2.47105),
        backgroundColor: [classificationColors.tree, classificationColors.barren, classificationColors.grass],
        borderColor: ['#282828'],
        borderWidth: 1,
        minBarLength: 5, // minimum bar height in pixels
      },
    ],
    labels: ['Tree', 'Barren', 'Grass'],
  };

  return (
    <Box
      style={{
        // position: 'absolute',
        pointerEvents: 'auto',
        bottom: '24px',
        left: '24px',
        padding: '8px 4px',
        height: '10rem',
        width: '15rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 130,
        background: '#fff',
        border: 'solid 1px #282828',
        borderRadius: '5px',
      }}>
      <Box align='center'>
        <Text style={{ fontSize: '12px', fontWeight: 700 }}>Classification Chart</Text>
        <Bar options={lineOptions} plugins={[legendMargin]} data={data} />
      </Box>
    </Box>
  );
};
